module.exports = __webpack_public_path__ + "img/S9011-PX.aed16fd3.jpg";